// Generated types for AttributeUsage
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLUsageReadAPI, SysMLUsageWriteAPI } from './sysmlusage';
import { SysMLUsageReadAPISchemaObject, SysMLUsageWriteAPISchemaObject } from './sysmlusage';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttributeUsageReadAPI extends SysMLUsageReadAPI {
}

export interface AttributeUsageWriteAPI extends SysMLUsageWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttributeUsageReadAPISchema: z.ZodType<AttributeUsageReadAPI> = SysMLUsageReadAPISchemaObject.extend({}).passthrough();

export const AttributeUsageWriteAPISchema: z.ZodType<AttributeUsageWriteAPI> = SysMLUsageWriteAPISchemaObject.extend({}).passthrough();
